import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, hasPageAccess, getAllowedPages } from '../services/api';

const ProtectedRoute = ({ children, requiredPage }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (requiredPage && !hasPageAccess(requiredPage)) {
    const allowedPages = getAllowedPages();
    if (allowedPages.includes('all') || allowedPages.includes('dashboard')) {
      return <Navigate to="/dashboard" replace />;
    } else if (allowedPages.length > 0) {
      return <Navigate to={`/${allowedPages[0]}`} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
